import { create } from 'zustand'
import { Plan } from '../service/plans'

// 사용자 플랜 정보 관련 전역 상태 관리

interface PlanStore {
  userPlanInfo: Plan | null
  isLoading: boolean
  planRefetch: (() => void) | null
  set: (payload: Partial<PlanStore>) => void
  setLoading: (loading: boolean) => void
  setRefetch: (refetch: () => void) => void
  setUserPlanInfo: (planInfo: Plan | null) => void
  destroy: () => void
}

const usePlanStore = create<PlanStore>((set) => ({
  userPlanInfo: null,
  isLoading: true,
  planRefetch: null,
  set: (payload) => set((state) => ({ ...state, ...payload })),
  setLoading: (loading) => set({ isLoading: loading }),
  setRefetch: (refetch) => set({ planRefetch: refetch }),
  setUserPlanInfo: (userPlanInfo) => set({ userPlanInfo }),
  destroy: () => set({ userPlanInfo: null, isLoading: true, planRefetch: null }),
}))

export default usePlanStore
